export const text = {
  title: "Update Profile",
  fullName: "Name",
  fullNamePlaceholder: "Enter name",
  displayName: "Display Name",
  displayNamePlaceholder: "Enter display name",
  basicInfo:
    "Basic info, like your name and address, that you use on Nio Platform.",
  basics: "Basics",
  email: "Email",
  socialLinks: "Social Links",
  personalInformation: "Personal Information",
  setUniqPassword: "Set a unique password to protect your account.",
};
